import { Box, Button } from '@material-ui/core';
import { DefaultDialog } from 'components/dialog/aisuk-dialogs/aisuk-default-dialog';
import { DialogContentProps } from 'components/dialog/types';

import AssignmentIcon from '@material-ui/icons/Assignment';
import DoneIcon from '@material-ui/icons/Done';

import { TextField } from 'components/text-field/text-field';
import React, { useState } from 'react';
import { Originator } from 'types';
import { getOriginatorFixedLink } from './reqister-utils';
export const RegisterPermaLinkDialog = ({
  detail,
}: DialogContentProps<Originator> & { detail: Originator }) => {
  const link = getOriginatorFixedLink(detail);
  const [coppied, setCoppied] = useState(false);
  navigator.clipboard.writeText(link);

  return (
    <DefaultDialog title="Trvalý odkaz" minWidth={700} actions={[]}>
      <TextField name="Odkaz" value={link} onChange={() => {}} />

      <Box width="100%" justifyContent="center" display="flex">
        {coppied ? (
          <Box mt={3} alignItems="center" display="flex">
            <DoneIcon /> Adresa URL trvalého odkazu byla zkopírována
          </Box>
        ) : (
          <Button
            style={{ marginTop: 16, justifySelf: 'center' }}
            onClick={() => {
              try {
                navigator.clipboard.writeText(link);
                setCoppied(true);
              } catch (error) {}
            }}
            variant="contained"
            color="primary"
          >
            <AssignmentIcon style={{ marginRight: 8 }} />
            Kopírovat trvalý odkaz do schránky
          </Button>
        )}
      </Box>
    </DefaultDialog>
  );
};
